var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',[_c('container',{ref:"container"},[_c('Widget',{attrs:{"id":3,"no-show-complete":""}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }